import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="py-8 md:py-16 px-4 bg-[#F0F9F0] border-t border-gray-200" data-id="element-119">
      <div className="max-w-3xl mx-auto bg-white rounded-2xl p-5 md:p-12 shadow-[0_2px_8px_rgba(0,0,0,0.08)] border-2 border-success-green text-center relative overflow-hidden" data-id="element-120">
        <div className="absolute top-0 left-0 w-full h-2 bg-success-green" data-id="element-121"></div>

        <ShieldCheckIcon className="w-16 h-16 md:w-24 md:h-24 text-cta-green mx-auto mb-4 md:mb-6" data-id="element-122" />

        <h2 className="text-xl md:text-3xl font-heading font-bold text-brown-dark mb-3 md:mb-4" data-id="element-123">
          Garantía de 14 días: "FACTURÁ O DÉJALO" — 100% satisfacción
        </h2>

        <p className="text-base md:text-lg text-gray-700 font-medium mb-3 leading-relaxed" data-id="element-124">
          Si en los próximos 14 días sientes que no era lo que esperabas, me
          escribes y te devuelvo el 100%.
        </p>

        <p className="md:text-xl font-bold text-brown-dark text-[14px]" data-id="element-125">
          Sin preguntas. Sin vueltas. Sin letra pequeña.
        </p>

        <p className="md:text-lg text-success-green font-bold mt-3 uppercase tracking-wider text-[24px]" data-id="element-126">
          El riesgo es mío.
        </p>
      </div>
    </section>;
}